import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getRelojes, importManualRelojes, deleteManualRelojes } from "../../../../api/reloj";
import { getMarcas } from "../../../../api/marca";
import { getModelos } from "../../../../api/modelo";
import { getConstants } from "../../../../api/constants";
import FiltersCard from "../../../components/filters/Filter";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  InputLabel,
  makeStyles,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Autorenew, NoteAdd, TrendingDown, TrendingUp } from "@material-ui/icons";
import Table from "../../../components/customTable/Table";
import {
  estadoCondicionLabelFromReloj,
  siNoFromContenido,
  relojUsadoBoolean,
  contenidoBooleanFromReloj,
} from "../../../utils/chronoRelojDisplay";

function getData(relojes, marcas, modelos) {
  let data = [];
  for (let i = 0; i < relojes.length; ++i) {
    const elem = {};
    const specs = relojes[i]?.specifications || {};

    elem.usado = estadoCondicionLabelFromReloj(relojes[i]);

    // Origen del reloj (manual vs chrono24/otros)
    const origin = relojes[i]?.origin || "chrono24";
    if (origin === "manual") {
      elem.origen = "Manual";
    } else if (origin === "chrono24") {
      elem.origen = "Chrono24";
    } else {
      elem.origen = origin || "Otro";
    }

    elem.calificacion = specs.estado?.calificacion || "---";
    elem.descripcion = specs.estado?.descripcion;
    
    // Obtener la localización: documento guardado o JSON crudo (data) — la agrupación por SKU a veces pierde el doc completo
    let localizacion = "";
    const rawData = relojes[i]?.data || {};
    if (relojes[i]?.seller?.country) {
      localizacion = relojes[i].seller.country;
    } else if (relojes[i]?.shipping?.location) {
      localizacion = relojes[i].shipping.location;
    } else if (specs.ubicaci_n) {
      localizacion = specs.ubicaci_n;
    } else if (rawData.seller?.country) {
      localizacion = rawData.seller.country;
    } else if (rawData.shipping?.location) {
      localizacion = rawData.shipping.location;
    } else if (rawData.specifications?.ubicaci_n) {
      localizacion = rawData.specifications.ubicaci_n;
    }

    const locTrim = String(localizacion || "").trim();
    if (locTrim.length === 2 && /^[a-z]{2}$/i.test(locTrim)) {
      const c = locTrim.toUpperCase();
      const isoEuropa = new Set([
        "ES", "FR", "DE", "IT", "PT", "GB", "NL", "BE", "RO", "CH", "AT", "DK", "SE", "NO", "FI", "PL", "GR", "IE", "LU", "MC", "IS", "LI", "CZ", "SK", "HU", "SI", "HR", "BG", "EE", "LV", "LT", "MT", "CY",
      ]);
      if (isoEuropa.has(c)) {
        localizacion = "Europa";
      } else if (c === "JP") {
        localizacion = "Japón";
      } else if (c === "US" || c === "CA") {
        localizacion = "EEUU";
      }
    }

    // Normalizar la localización a los valores esperados (Europa, Japón, EEUU, Otros)
    if (localizacion && localizacion !== "Europa" && localizacion !== "Japón" && localizacion !== "EEUU") {
      const localizacionLower = localizacion.toLowerCase();
      if (localizacionLower.includes("europa") || localizacionLower.includes("europe") || 
          localizacionLower.includes("españa") || localizacionLower.includes("spain") ||
          localizacionLower.includes("francia") || localizacionLower.includes("france") ||
          localizacionLower.includes("alemania") || localizacionLower.includes("germany") ||
          localizacionLower.includes("italia") || localizacionLower.includes("italy") ||
          localizacionLower.includes("suiza") || localizacionLower.includes("switzerland") ||
          localizacionLower.includes("holanda") || localizacionLower.includes("netherlands") ||
          localizacionLower.includes("países bajos") || localizacionLower.includes("paises bajos") ||
          localizacionLower.includes("portugal") ||
          localizacionLower.includes("reino unido") || localizacionLower.includes("united kingdom") ||
          localizacionLower.includes("bélgica") || localizacionLower.includes("belgium") ||
          localizacionLower.includes("austria") ||
          localizacionLower.includes("dinamarca") || localizacionLower.includes("denmark") ||
          localizacionLower.includes("suecia") || localizacionLower.includes("sweden") ||
          localizacionLower.includes("noruega") || localizacionLower.includes("norway") ||
          localizacionLower.includes("finlandia") || localizacionLower.includes("finland") ||
          localizacionLower.includes("polonia") || localizacionLower.includes("poland") ||
          localizacionLower.includes("grecia") || localizacionLower.includes("greece") ||
          localizacionLower.includes("irlanda") || localizacionLower.includes("ireland") ||
          localizacionLower.includes("rumania") || localizacionLower.includes("romania")) {
        localizacion = "Europa";
      } else if (localizacionLower.includes("japón") || localizacionLower.includes("japan")) {
        localizacion = "Japón";
      } else if (localizacionLower.includes("eeuu") || localizacionLower.includes("usa") ||
                 localizacionLower.includes("united states") || localizacionLower.includes("estados unidos")) {
        localizacion = "EEUU";
      } else {
        localizacion = "Otros";
      }
    }
    
    elem.localizacionVendedor = localizacion || "---";
    elem.estuche = siNoFromContenido(relojes[i], "estuche");
    elem.documento = siNoFromContenido(relojes[i], "documento");
    const amount = parseFloat(relojes[i]?.price?.amount);
    elem.precio = Number.isFinite(amount)
      ? amount.toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR",
        })
      : "---";
    elem._priceCurrent = Number.isFinite(amount) ? amount : null;
    const prevAmt = relojes[i]?.scraperPreviousPriceAmount;
    elem._pricePrevious =
      prevAmt != null && !Number.isNaN(Number(prevAmt)) ? Number(prevAmt) : null;
    
    // Obtener el modelo: puede ser un ObjectId o un objeto populado
    let modeloNombre = "";
    const relojModelo = relojes[i]?.specifications?.reloj_modelo;
    if (relojModelo) {
      if (typeof relojModelo === "object" && relojModelo.nombre) {
        // Ya está populado
        modeloNombre = relojModelo.nombre;
      } else {
        // Es un ObjectId, buscar en el array de modelos
        const modeloId = typeof relojModelo === "object" && relojModelo._id 
          ? relojModelo._id.toString() 
          : relojModelo.toString();
        const modeloEncontrado = modelos.find((m) => {
          const mId = m._id ? m._id.toString() : m.toString();
          return mId === modeloId;
        });
        modeloNombre = modeloEncontrado?.nombre || "";
      }
    }
    elem.modelo = modeloNombre;
    if (!elem.modelo) {
      const rawNombre = relojes[i]?.data?.specifications?.reloj_modelo;
      if (typeof rawNombre === "string" && rawNombre.trim()) {
        elem.modelo = rawNombre.trim();
      }
    }
    if (!elem.modelo) {
      const n =
        typeof relojes[i]?.data?.name === "string"
          ? relojes[i].data.name.trim()
          : "";
      const t =
        typeof relojes[i]?.data?.title === "string"
          ? relojes[i].data.title.trim()
          : "";
      if (n || t) elem.modelo = n || t;
    }
    
    // Obtener el nombre de la marca: puede ser un ObjectId o un objeto populado
    let marcaNombre = "";
    const relojBrand = relojes[i]?.brand;
    if (relojBrand) {
      // Verificar si es un objeto populado con nombre
      if (typeof relojBrand === "object" && relojBrand.nombre) {
        // Ya está populado, usar directamente el nombre
        marcaNombre = relojBrand.nombre;
      } else {
        // Es un ObjectId, buscar en el array de marcas
        const brandId = typeof relojBrand === "object" && relojBrand._id 
          ? relojBrand._id.toString() 
          : relojBrand.toString();
        const marcaEncontrada = marcas.find((x) => {
          const xId = x._id ? x._id.toString() : x.toString();
          return xId === brandId;
        });
        marcaNombre = marcaEncontrada?.nombre || "";
      }
    }
    elem.marca = marcaNombre;
    const refreshAt = relojes[i]?.lastScraperRefreshAt;
    const importedAt = relojes[i]?.chronoImportedAt;
    const pending = relojes[i]?.pendingApproval === true;
    if (importedAt != null && pending && refreshAt == null) {
      elem._scrapeKind = "new";
      elem._scrapeDateLabel = "";
    } else if (refreshAt != null) {
      elem._scrapeKind = "updated";
      elem._scrapeDateLabel = new Date(refreshAt).toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } else {
      elem._scrapeKind = null;
      elem._scrapeDateLabel = "";
    }
    elem.id = relojes[i]?._id;
    elem.sku = relojes[i]?.sku;
    if (elem._scrapeKind === "new") {
      elem._rowStyle = "new";
    } else if (elem._scrapeKind === "updated") {
      elem._rowStyle = "updated";
    } else {
      elem._rowStyle = null;
    }
    data = data.concat(elem);
  }
  return data;
}

// Función para calcular estadísticas de precios
function calculatePriceStats(relojes, constants = null) {
  if (!relojes || relojes.length === 0) return null;

  const generalDiscountPercent = constants?.generalDiscountPercent || 0;

  const formatPrice = (price) => {
    if (!price || isNaN(price)) return "N/A";
    return `${price.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
  };

  const formatDiscount = (discount) => {
    if (discount === null || discount === undefined || isNaN(discount)) return "N/A";
    return `${discount.toFixed(2)}%`;
  };

  const calculateAverage = (items) => {
    if (!items || items.length === 0) return null;
    const validPrices = items
      .map(r => parseFloat(r?.price?.amount))
      .filter(p => !isNaN(p) && p > 0);
    if (validPrices.length === 0) return null;
    return validPrices.reduce((sum, p) => sum + p, 0) / validPrices.length;
  };

  const calculateMinMax = (items) => {
    if (!items || items.length === 0) return { min: null, max: null };
    const validPrices = items
      .map(r => parseFloat(r?.price?.amount))
      .filter(p => !isNaN(p) && p > 0);
    if (validPrices.length === 0) return { min: null, max: null };
    return {
      min: Math.min(...validPrices),
      max: Math.max(...validPrices)
    };
  };

  // Función para eliminar outliers usando IQR (igual que en la tasación)
  const eliminarOutliers = (datos, q1Percent = 25, q3Percent = 75) => {
    if (!datos || datos.length < 4) return { datos: datos, descartados: 0 };
    
    const datosOrdenados = [...datos].sort((a, b) => a - b);
    const n = datosOrdenados.length;
    
    // Usar clamp 0-1 igual que en la tasación
    const q1Factor = Math.min(Math.max(q1Percent / 100, 0), 1);
    const q3Factor = Math.min(Math.max(q3Percent / 100, 0), 1);
    
    // Calcular Q1 y Q3
    const q1Index = Math.min(n - 1, Math.max(0, Math.floor(n * q1Factor)));
    const q3Index = Math.min(n - 1, Math.max(0, Math.floor(n * q3Factor)));
    const q1 = datosOrdenados[q1Index];
    const q3 = datosOrdenados[q3Index];
    
    // Calcular IQR
    const iqr = q3 - q1;
    
    // Definir límites para outliers
    const limiteInferior = q1 - 1.5 * iqr;
    const limiteSuperior = q3 + 1.5 * iqr;
    
    // Debug: mostrar información sobre los límites
    console.log(`[OUTLIERS] Total datos: ${n}, Q1 (índice ${q1Index}): ${q1}, Q3 (índice ${q3Index}): ${q3}`);
    console.log(`[OUTLIERS] IQR: ${iqr}, Límite inferior: ${limiteInferior}, Límite superior: ${limiteSuperior}`);
    console.log(`[OUTLIERS] Precio mínimo en datos: ${datosOrdenados[0]}, Precio máximo en datos: ${datosOrdenados[n - 1]}`);
    
    // Filtrar outliers
    const datosSinOutliers = datos.filter(
      (valor) => valor >= limiteInferior && valor <= limiteSuperior
    );
    
    const descartados = datos.length - datosSinOutliers.length;
    console.log(`[OUTLIERS] Datos válidos: ${datosSinOutliers.length}, Descartados: ${descartados}`);
    
    // Mostrar algunos ejemplos de datos descartados
    const datosDescartados = datos.filter(
      (valor) => valor < limiteInferior || valor > limiteSuperior
    );
    if (datosDescartados.length > 0) {
      console.log(`[OUTLIERS] Ejemplos de precios descartados (primeros 10):`, datosDescartados.slice(0, 10).sort((a, b) => a - b));
    }
    
    return {
      datos: datosSinOutliers.length > 0 ? datosSinOutliers : datos,
      descartados: descartados
    };
  };

  // Función para calcular precios con descuento aplicado (igual que en la tasación)
  const calculatePricesWithDiscount = (items) => {
    if (!items || items.length === 0) return { min: null, max: null, avg: null, minSinOutliers: null, maxSinOutliers: null, avgSinOutliers: null, descartados: 0, total: 0 };
    
    // Calcular descuento individual para cada reloj (igual que en la tasación)
    const relojesWithDiscount = items.map(r => {
      const precioOriginal = parseFloat(r?.price?.amount);
      if (isNaN(precioOriginal) || precioOriginal <= 0) return null;
      
      // Calcular descuento individual según jerarquía (igual que en la tasación)
      let modelDiscount = 0;
      if (r?.specifications?.reloj_modelo) {
        const modelo = r.specifications.reloj_modelo;
        if (typeof modelo === 'object' && modelo !== null && !Array.isArray(modelo)) {
          const discountValue = modelo.discountPercent;
          if (discountValue !== undefined && discountValue !== null) {
            const parsed = Number(discountValue);
            if (!isNaN(parsed)) {
              modelDiscount = parsed;
            }
          }
        }
      }
      
      let brandDiscount = 0;
      if (r?.brand) {
        const brand = r.brand;
        if (typeof brand === 'object' && brand !== null && !Array.isArray(brand)) {
          const discountValue = brand.discountPercent;
          if (discountValue !== undefined && discountValue !== null) {
            const parsed = Number(discountValue);
            if (!isNaN(parsed)) {
              brandDiscount = parsed;
            }
          }
        }
      }
      
      // Aplicar jerarquía de descuentos (igual que en la tasación)
      let appliedDiscount = 0;
      if (modelDiscount !== 0) {
        appliedDiscount = modelDiscount;
      } else if (modelDiscount === 0 && brandDiscount !== 0) {
        appliedDiscount = brandDiscount;
      } else {
        appliedDiscount = generalDiscountPercent;
      }
      
      // Calcular precio con descuento
      const discounted = parseFloat((precioOriginal * (1 - appliedDiscount / 100)).toFixed(2));
      
      // Obtener marca y SKU para agrupar (igual que en la tasación)
      const brandId = r.brand && r.brand._id ? r.brand._id.toString() : (r.brand ? r.brand.toString() : null);
      const sku = r.sku || null;
      
      return { reloj: r, priceNum: precioOriginal, discounted, appliedDiscount, brandId, sku };
    }).filter(item => item !== null && item.discounted !== null && !isNaN(item.discounted));
    
    if (relojesWithDiscount.length === 0) return { min: null, max: null, avg: null, minSinOutliers: null, maxSinOutliers: null, avgSinOutliers: null, descartados: 0, total: 0 };
    
    // Agrupar relojes por marca y SKU EXACTO (igual que en la tasación)
    const groupedByBrandAndSku = {};
    relojesWithDiscount.forEach((item) => {
      if (item.discounted !== null && !isNaN(item.discounted) && item.brandId && item.sku) {
        const key = `${item.brandId}_${item.sku}`;
        if (!groupedByBrandAndSku[key]) {
          groupedByBrandAndSku[key] = {
            brandId: item.brandId,
            sku: item.sku,
            precios: [],
            relojes: []
          };
        }
        groupedByBrandAndSku[key].precios.push(item.discounted);
        groupedByBrandAndSku[key].relojes.push(item);
      }
    });
    
    // Usar TODOS los precios individuales de todos los grupos (igual que en la tasación)
    const preciosConDescuento = [];
    Object.values(groupedByBrandAndSku).forEach((group) => {
      // Agregar TODOS los precios individuales del grupo, no solo el promedio
      preciosConDescuento.push(...group.precios);
    });
    
    // Si no hay precios agrupados, usar todos los precios individuales como fallback
    if (preciosConDescuento.length === 0) {
      preciosConDescuento.push(...relojesWithDiscount.map((r) => r.discounted).filter((precio) => !isNaN(precio) && precio !== null));
    } else {
      // Si hay agrupación, también incluir relojes que no tienen brandId o sku válidos
      const relojesSinAgrupar = relojesWithDiscount.filter(item => !item.brandId || !item.sku);
      if (relojesSinAgrupar.length > 0) {
        preciosConDescuento.push(...relojesSinAgrupar.map((r) => r.discounted).filter((precio) => !isNaN(precio) && precio !== null));
      }
    }
    
    // Debug: mostrar información sobre la agrupación (igual que en la tasación)
    if (preciosConDescuento.length > 0) {
      const gruposInfo = Object.values(groupedByBrandAndSku).map(g => ({
        sku: g.sku,
        cantidad: g.precios.length,
        precios: g.precios.slice(0, 5) // Solo primeros 5 para no saturar
      }));
      console.log(`[BACKOFFICE] Total relojes para cálculo: ${items.length}`);
      console.log(`[BACKOFFICE] Grupos formados: ${gruposInfo.length}`);
      gruposInfo.forEach(g => {
        console.log(`[BACKOFFICE] SKU ${g.sku}: ${g.cantidad} relojes, precios: ${g.precios.join(', ')}`);
      });
      console.log(`[BACKOFFICE] Total precios para cálculo: ${preciosConDescuento.length}`);
      console.log(`[BACKOFFICE] Precios (primeros 10):`, preciosConDescuento.slice(0, 10));
      console.log(`[BACKOFFICE] Precios (últimos 10):`, preciosConDescuento.slice(-10));
      console.log(`[BACKOFFICE] Precio mínimo:`, Math.min(...preciosConDescuento));
      console.log(`[BACKOFFICE] Precio máximo:`, Math.max(...preciosConDescuento));
      const avg = preciosConDescuento.reduce((sum, p) => sum + p, 0) / preciosConDescuento.length;
      console.log(`[BACKOFFICE] Precio promedio:`, avg);
      
      // Debug: verificar Q1/Q3 y outliers
      if (preciosConDescuento.length >= 4) {
        const q1Percent = constants?.outlierQ1Percent !== undefined && constants?.outlierQ1Percent !== null
          ? constants.outlierQ1Percent
          : 25;
        const q3Percent = constants?.outlierQ3Percent !== undefined && constants?.outlierQ3Percent !== null
          ? constants.outlierQ3Percent
          : 75;
        console.log(`[BACKOFFICE] Q1: ${q1Percent}%, Q3: ${q3Percent}%`);
        console.log(`[BACKOFFICE] Total precios antes de eliminar outliers: ${preciosConDescuento.length}`);
        
        const resultado = eliminarOutliers(preciosConDescuento, q1Percent, q3Percent);
        console.log(`[BACKOFFICE] Precios sin outliers: ${resultado.datos.length}, descartados: ${resultado.descartados}`);
        console.log(`[BACKOFFICE] Total relojes usados: ${preciosConDescuento.length} (${resultado.datos.length} válidos + ${resultado.descartados} descartados)`);
        if (resultado.datos.length > 0) {
          const avgSinOutliers = resultado.datos.reduce((sum, p) => sum + p, 0) / resultado.datos.length;
          console.log(`[BACKOFFICE] Precio promedio sin outliers:`, avgSinOutliers);
        }
      }
    }
    
    if (preciosConDescuento.length === 0) return { min: null, max: null, avg: null, minSinOutliers: null, maxSinOutliers: null, avgSinOutliers: null, descartados: 0, total: 0 };
    
    // Precios sin eliminar outliers
    const min = Math.min(...preciosConDescuento);
    const max = Math.max(...preciosConDescuento);
    const avg = parseFloat(
      (preciosConDescuento.reduce((sum, p) => sum + p, 0) / preciosConDescuento.length).toFixed(2)
    );
    
    // Eliminar outliers (igual que en la tasación)
    const q1Percent = constants?.outlierQ1Percent !== undefined && constants?.outlierQ1Percent !== null
      ? constants.outlierQ1Percent
      : 25;
    const q3Percent = constants?.outlierQ3Percent !== undefined && constants?.outlierQ3Percent !== null
      ? constants.outlierQ3Percent
      : 75;
    
    // Si hay muy pocos datos, no filtrar outliers (igual que en la tasación)
    let preciosSinOutliers = preciosConDescuento;
    let descartados = 0;
    if (preciosConDescuento.length >= 4) {
      const resultado = eliminarOutliers(preciosConDescuento, q1Percent, q3Percent);
      preciosSinOutliers = resultado.datos.length > 0 ? resultado.datos : preciosConDescuento;
      descartados = resultado.descartados;
    }
    
    // Calcular estadísticas sin outliers (igual que en la tasación)
    const minSinOutliers = preciosSinOutliers.length > 0 ? Math.min(...preciosSinOutliers) : null;
    const maxSinOutliers = preciosSinOutliers.length > 0 ? Math.max(...preciosSinOutliers) : null;
    const avgSinOutliers = preciosSinOutliers.length > 0 
      ? parseFloat(
          (preciosSinOutliers.reduce((sum, p) => sum + p, 0) / preciosSinOutliers.length).toFixed(2)
        )
      : null;
    
    return {
      min,
      max,
      avg,
      minSinOutliers,
      maxSinOutliers,
      avgSinOutliers,
      descartados,
      total: preciosConDescuento.length // Total de relojes usados para el cálculo
    };
  };

  // Función para calcular descuentos promedio de un grupo
  const calculateDiscounts = (items) => {
    if (!items || items.length === 0) return { marca: null, modelo: null, general: generalDiscountPercent, aplicado: null };
    
    const discounts = items.map((r) => {
      // Acceder al descuento del modelo - puede estar como objeto populado o como ID
      let modelDiscount = 0;
      const modelo = r?.specifications?.reloj_modelo;
      if (modelo) {
        // Verificar si es un objeto y tiene discountPercent
        if (typeof modelo === 'object' && modelo !== null && !Array.isArray(modelo)) {
          // Puede ser un objeto populado con discountPercent
          const discountValue = modelo.discountPercent;
          if (discountValue !== undefined && discountValue !== null) {
            const parsed = Number(discountValue);
            if (!isNaN(parsed)) {
              modelDiscount = parsed;
            }
          }
        }
      }
      
      // Acceder al descuento de la marca - puede estar como objeto populado o como ID
      let brandDiscount = 0;
      const brand = r?.brand;
      if (brand) {
        // Verificar si es un objeto y tiene discountPercent
        if (typeof brand === 'object' && brand !== null && !Array.isArray(brand)) {
          // Puede ser un objeto populado con discountPercent
          const discountValue = brand.discountPercent;
          if (discountValue !== undefined && discountValue !== null) {
            const parsed = Number(discountValue);
            if (!isNaN(parsed)) {
              brandDiscount = parsed;
            }
          }
        }
      }
      
      
      // Calcular descuento aplicado como el máximo entre los tres descuentos
      const appliedDiscount = Math.max(modelDiscount, brandDiscount, generalDiscountPercent);
      
      return {
        marca: brandDiscount,
        modelo: modelDiscount,
        general: generalDiscountPercent,
        aplicado: appliedDiscount
      };
    });

    // Calcular promedios - considerar todos los descuentos (incluyendo 0)
    const validMarca = discounts.filter(d => d.marca !== null && !isNaN(d.marca) && d.marca >= 0);
    const validModelo = discounts.filter(d => d.modelo !== null && !isNaN(d.modelo) && d.modelo >= 0);

    // Calcular promedio de marca (solo si hay al menos uno con descuento > 0, sino mostrar null)
    const marcaWithDiscount = discounts.filter(d => d.marca !== null && !isNaN(d.marca) && d.marca > 0);
    const modeloWithDiscount = discounts.filter(d => d.modelo !== null && !isNaN(d.modelo) && d.modelo > 0);

    // Calcular promedios de descuentos
    const promedioMarca = marcaWithDiscount.length > 0 
      ? marcaWithDiscount.reduce((sum, d) => sum + d.marca, 0) / marcaWithDiscount.length 
      : (validMarca.length > 0 ? 0 : null);
    
    const promedioModelo = modeloWithDiscount.length > 0 
      ? modeloWithDiscount.reduce((sum, d) => sum + d.modelo, 0) / modeloWithDiscount.length 
      : (validModelo.length > 0 ? 0 : null);

    // El descuento aplicado es el máximo entre los promedios de marca, modelo y general
    const descuentosParaMax = [
      promedioMarca !== null ? promedioMarca : 0,
      promedioModelo !== null ? promedioModelo : 0,
      generalDiscountPercent
    ];
    const descuentoAplicado = Math.max(...descuentosParaMax);

    return {
      marca: promedioMarca,
      modelo: promedioModelo,
      general: generalDiscountPercent,
      aplicado: descuentoAplicado
    };
  };

  // Filtrar relojes según diferentes criterios (usa fallback desde data Chrono)
  const usado = relojes.filter((r) => relojUsadoBoolean(r) === true);
  const sinEstrenar = relojes.filter((r) => relojUsadoBoolean(r) === false);

  const soloReloj = relojes.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") !== true &&
      contenidoBooleanFromReloj(r, "documento") !== true
    );
  });

  const conEstuche = relojes.filter(
    (r) => contenidoBooleanFromReloj(r, "estuche") === true
  );

  const conDocumentos = relojes.filter(
    (r) => contenidoBooleanFromReloj(r, "documento") === true
  );

  const conEstucheYDocumentos = relojes.filter(
    (r) =>
      contenidoBooleanFromReloj(r, "estuche") === true &&
      contenidoBooleanFromReloj(r, "documento") === true
  );

  // Combinaciones
  const usadoSoloReloj = usado.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") !== true &&
      contenidoBooleanFromReloj(r, "documento") !== true
    );
  });

  const usadoConEstuche = usado.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") === true &&
      contenidoBooleanFromReloj(r, "documento") !== true
    );
  });

  const usadoConDocumentos = usado.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") !== true &&
      contenidoBooleanFromReloj(r, "documento") === true
    );
  });

  const usadoConEstucheYDocumentos = usado.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") === true &&
      contenidoBooleanFromReloj(r, "documento") === true
    );
  });

  const sinEstrenarSoloReloj = sinEstrenar.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") !== true &&
      contenidoBooleanFromReloj(r, "documento") !== true
    );
  });

  const sinEstrenarConEstuche = sinEstrenar.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") === true &&
      contenidoBooleanFromReloj(r, "documento") !== true
    );
  });

  const sinEstrenarConDocumentos = sinEstrenar.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") !== true &&
      contenidoBooleanFromReloj(r, "documento") === true
    );
  });

  const sinEstrenarConEstucheYDocumentos = sinEstrenar.filter((r) => {
    return (
      contenidoBooleanFromReloj(r, "estuche") === true &&
      contenidoBooleanFromReloj(r, "documento") === true
    );
  });

  // Calcular promedios, min/max y descuentos
  const stats = {
    general: { 
      precio: calculateAverage(relojes), 
      minMax: calculateMinMax(relojes),
      descuentos: calculateDiscounts(relojes),
      conDescuento: null
    },
    usado: { 
      precio: calculateAverage(usado), 
      minMax: calculateMinMax(usado),
      descuentos: calculateDiscounts(usado),
      conDescuento: null
    },
    sinEstrenar: { 
      precio: calculateAverage(sinEstrenar), 
      minMax: calculateMinMax(sinEstrenar),
      descuentos: calculateDiscounts(sinEstrenar),
      conDescuento: null
    },
    soloReloj: { 
      precio: calculateAverage(soloReloj), 
      minMax: calculateMinMax(soloReloj),
      descuentos: calculateDiscounts(soloReloj),
      conDescuento: null
    },
    conEstuche: { 
      precio: calculateAverage(conEstuche), 
      minMax: calculateMinMax(conEstuche),
      descuentos: calculateDiscounts(conEstuche),
      conDescuento: null
    },
    conDocumentos: { 
      precio: calculateAverage(conDocumentos), 
      minMax: calculateMinMax(conDocumentos),
      descuentos: calculateDiscounts(conDocumentos),
      conDescuento: null
    },
    conEstucheYDocumentos: { 
      precio: calculateAverage(conEstucheYDocumentos), 
      minMax: calculateMinMax(conEstucheYDocumentos),
      descuentos: calculateDiscounts(conEstucheYDocumentos),
      conDescuento: null
    },
    usadoSoloReloj: { 
      precio: calculateAverage(usadoSoloReloj), 
      minMax: calculateMinMax(usadoSoloReloj),
      descuentos: calculateDiscounts(usadoSoloReloj),
      conDescuento: null
    },
    usadoConEstuche: { 
      precio: calculateAverage(usadoConEstuche), 
      minMax: calculateMinMax(usadoConEstuche),
      descuentos: calculateDiscounts(usadoConEstuche),
      conDescuento: null
    },
    usadoConDocumentos: { 
      precio: calculateAverage(usadoConDocumentos), 
      minMax: calculateMinMax(usadoConDocumentos),
      descuentos: calculateDiscounts(usadoConDocumentos),
      conDescuento: null
    },
    usadoConEstucheYDocumentos: { 
      precio: calculateAverage(usadoConEstucheYDocumentos), 
      minMax: calculateMinMax(usadoConEstucheYDocumentos),
      descuentos: calculateDiscounts(usadoConEstucheYDocumentos),
      conDescuento: null
    },
    sinEstrenarSoloReloj: { 
      precio: calculateAverage(sinEstrenarSoloReloj), 
      minMax: calculateMinMax(sinEstrenarSoloReloj),
      descuentos: calculateDiscounts(sinEstrenarSoloReloj),
      conDescuento: null
    },
    sinEstrenarConEstuche: { 
      precio: calculateAverage(sinEstrenarConEstuche), 
      minMax: calculateMinMax(sinEstrenarConEstuche),
      descuentos: calculateDiscounts(sinEstrenarConEstuche),
      conDescuento: null
    },
    sinEstrenarConDocumentos: { 
      precio: calculateAverage(sinEstrenarConDocumentos), 
      minMax: calculateMinMax(sinEstrenarConDocumentos),
      descuentos: calculateDiscounts(sinEstrenarConDocumentos),
      conDescuento: null
    },
    sinEstrenarConEstucheYDocumentos: { 
      precio: calculateAverage(sinEstrenarConEstucheYDocumentos), 
      minMax: calculateMinMax(sinEstrenarConEstucheYDocumentos),
      descuentos: calculateDiscounts(sinEstrenarConEstucheYDocumentos),
      conDescuento: null
    },
  };

  // Calcular precios con descuento para cada categoría
  Object.keys(stats).forEach(key => {
    const categoria = stats[key];
    let items = [];
    switch(key) {
      case 'general': items = relojes; break;
      case 'usado': items = usado; break;
      case 'sinEstrenar': items = sinEstrenar; break;
      case 'soloReloj': items = soloReloj; break;
      case 'conEstuche': items = conEstuche; break;
      case 'conDocumentos': items = conDocumentos; break;
      case 'conEstucheYDocumentos': items = conEstucheYDocumentos; break;
      case 'usadoSoloReloj': items = usadoSoloReloj; break;
      case 'usadoConEstuche': items = usadoConEstuche; break;
      case 'usadoConDocumentos': items = usadoConDocumentos; break;
      case 'usadoConEstucheYDocumentos': items = usadoConEstucheYDocumentos; break;
      case 'sinEstrenarSoloReloj': items = sinEstrenarSoloReloj; break;
      case 'sinEstrenarConEstuche': items = sinEstrenarConEstuche; break;
      case 'sinEstrenarConDocumentos': items = sinEstrenarConDocumentos; break;
      case 'sinEstrenarConEstucheYDocumentos': items = sinEstrenarConEstucheYDocumentos; break;
    }
    categoria.conDescuento = calculatePricesWithDiscount(items);
  });

  // Función helper para renderizar una tarjeta de estadística
  const renderStatCard = (title, stat) => (
    <div style={{ padding: "12px", backgroundColor: "white", borderRadius: "4px", border: "1px solid #ddd" }}>
      <strong style={{ color: "#666" }}>{title}</strong>
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#333", marginTop: "5px" }}>
        Precio Medio: {formatPrice(stat.precio)}
      </div>
      {stat.minMax && (stat.minMax.min !== null || stat.minMax.max !== null) && (
        <div style={{ marginTop: "5px", fontSize: "14px", color: "#555" }}>
          <div>Mínimo: {formatPrice(stat.minMax.min)}</div>
          <div>Máximo: {formatPrice(stat.minMax.max)}</div>
        </div>
      )}
      <div style={{ marginTop: "8px", fontSize: "12px", color: "#888" }}>
        <div>Descuento Marca: {formatDiscount(stat.descuentos.marca)}</div>
        <div>Descuento Modelo: {formatDiscount(stat.descuentos.modelo)}</div>
        <div>Descuento General: {formatDiscount(stat.descuentos.general)}</div>
        <div style={{ fontWeight: "bold", marginTop: "4px" }}>Descuento Aplicado: {formatDiscount(stat.descuentos.aplicado)}</div>
      </div>
      {stat.conDescuento && (
        <div style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #ddd", fontSize: "12px" }}>
          <div style={{ fontWeight: "bold", color: "#333", marginBottom: "5px" }}>Con Descuento Aplicado:</div>
          {stat.conDescuento.min !== null && (
            <div>Mínimo: {formatPrice(stat.conDescuento.min)}</div>
          )}
          {stat.conDescuento.max !== null && (
            <div>Máximo: {formatPrice(stat.conDescuento.max)}</div>
          )}
          {stat.conDescuento.avg !== null && (
            <div>Medio: {formatPrice(stat.conDescuento.avg)}</div>
          )}
          {stat.conDescuento.minSinOutliers !== null && (
            <div style={{ marginTop: "5px", color: "#0066cc" }}>
              <div>Mínimo (sin outliers): {formatPrice(stat.conDescuento.minSinOutliers)}</div>
              <div>Máximo (sin outliers): {formatPrice(stat.conDescuento.maxSinOutliers)}</div>
              <div>Medio (sin outliers): {formatPrice(stat.conDescuento.avgSinOutliers)}</div>
              {stat.conDescuento.descartados > 0 && stat.conDescuento.total && (
                <div style={{ color: "#cc0000", fontWeight: "bold", marginTop: "3px" }}>
                  Relojes descartados: {stat.conDescuento.descartados} de {stat.conDescuento.total} total
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "15px" }}>
      {renderStatCard("Precio Medio", stats.general)}
      {renderStatCard("Precio Medio Usado", stats.usado)}
      {renderStatCard("Precio Medio Sin Estrenar", stats.sinEstrenar)}
      {renderStatCard("Precio Medio Solo Reloj", stats.soloReloj)}
      {renderStatCard("Precio Medio con Estuche", stats.conEstuche)}
      {renderStatCard("Precio Medio con Documentos", stats.conDocumentos)}
      {renderStatCard("Precio Medio con Estuche y Documentos", stats.conEstucheYDocumentos)}
      {renderStatCard("Usado - Solo Reloj", stats.usadoSoloReloj)}
      {renderStatCard("Usado - Con Estuche", stats.usadoConEstuche)}
      {renderStatCard("Usado - Con Documentos", stats.usadoConDocumentos)}
      {renderStatCard("Usado - Con Estuche y Documentos", stats.usadoConEstucheYDocumentos)}
      {renderStatCard("Sin Estrenar - Solo Reloj", stats.sinEstrenarSoloReloj)}
      {renderStatCard("Sin Estrenar - Con Estuche", stats.sinEstrenarConEstuche)}
      {renderStatCard("Sin Estrenar - Con Documentos", stats.sinEstrenarConDocumentos)}
      {renderStatCard("Sin Estrenar - Con Estuche y Documentos", stats.sinEstrenarConEstucheYDocumentos)}
    </div>
  );
}

const initialFilters = {
  marcas: [],
  localizaciones: [],
  desde: "",
  hasta: "",
  usado: null,
  sku: "",
  skuExact: false, // Si es true, busca SKU exacto; si es false, busca flexible (como ahora)
  origin: "chrono24", // Por defecto solo mostrar relojes de Chrono24
  timeFilter: "always", // "1h", "24h", "week", "month" (comentado), "always"
  /** Solo filas refrescadas por el scraper (tienen lastScraperRefreshAt) */
  soloRefreshScraper: false,
  /** Ocultar anuncios con precio 0 € (recomendado en scraping) */
  excludeZeroPrice: true,
};
const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function RelojesPage() {
  const [data, setData] = useState([]);
  const [rawRelojes, setRawRelojes] = useState([]); // Guardar los relojes originales para calcular estadísticas
  const [marcas, setMarcas] = useState([]);
  const [constants, setConstants] = useState(null); // Guardar las constantes para obtener el descuento general
  const [refresh, setRefresh] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const [importing, setImporting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [csvText, setCsvText] = useState("");
  const history = useHistory();
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState("lastScraperRefreshAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const columns = useMemo(() => {
    const baseColumns = [
      { accessor: "sku", Header: "idRef", disableFilters: true },
      { accessor: "marca", Header: "Marca", disableFilters: true },
      { accessor: "modelo", Header: "Modelo", disableFilters: true },
      { accessor: "usado", Header: "Estado", disableFilters: true },
      {
        accessor: "origen",
        Header: "Origen",
        disableFilters: true,
      },
      {
        accessor: "localizacionVendedor",
        Header: "Localización",
        disableFilters: true,
      },
      { accessor: "estuche", Header: "Estuche", disableFilters: true },
      { accessor: "documento", Header: "Documento", disableFilters: true },
      {
        id: "scrape",
        Header: "Scrape",
        disableFilters: true,
        accessor: "_scrapeKind",
        Cell: ({ row }) => {
          const kind = row?.original?._scrapeKind;
          const dateLabel = row?.original?._scrapeDateLabel || "";
          if (kind === "updated") {
            return (
              <Tooltip title={`Actualizado por scraper: ${dateLabel}`}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Autorenew fontSize="small" style={{ color: "#2e7d32" }} />
                  <span style={{ fontSize: 12, color: "#333" }}>{dateLabel}</span>
                </span>
              </Tooltip>
            );
          }
          if (kind === "new") {
            return (
              <Tooltip title="Alta desde Chrono24, pendiente de aprobación">
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  <NoteAdd fontSize="small" style={{ color: "#1565c0" }} />
                  <span style={{ fontSize: 12, color: "#333" }}>Nuevo</span>
                </span>
              </Tooltip>
            );
          }
          return "";
        },
      },
      { accessor: "precio", Header: "Precio", disableFilters: true,
        Cell: ({ row }) => {
          const precio = row?.original?.precio ?? "---";
          const kind = row?.original?._scrapeKind;
          const cur = row?.original?._priceCurrent;
          const prev = row?.original?._pricePrevious;
          if (
            kind !== "updated" ||
            cur == null ||
            prev == null ||
            Math.abs(cur - prev) < 0.01
          ) {
            return <span>{precio}</span>;
          }
          const diff = cur - prev;
          const absStr = Math.abs(diff).toLocaleString("es-ES", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
          const deltaStr = diff > 0 ? `+${absStr} €` : `−${absStr} €`;
          const prevStr = prev.toLocaleString("es-ES", {
            style: "currency",
            currency: "EUR",
          });
          const tip = `Antes del último scraping: ${prevStr} → ahora ${precio}`;
          return (
            <Tooltip title={tip}>
              <span style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", gap: 2 }}>
                <span>{precio}</span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 12,
                    color: diff > 0 ? "#c62828" : "#2e7d32",
                  }}
                >
                  {diff > 0 ? (
                    <TrendingUp fontSize="inherit" />
                  ) : (
                    <TrendingDown fontSize="inherit" />
                  )}
                  {deltaStr}
                </span>
              </span>
            </Tooltip>
          );
        },
      },
    ];
    return baseColumns;
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Obtener constantes para el descuento general
        const resConstants = await getConstants();
        if (resConstants.status === 200 || resConstants.status === 304) {
          setConstants(resConstants.data || null);
        }
        
        const [resMarcas, resModelos] = await Promise.all([
          getMarcas(),
          getModelos({ page: 1, limit: 10000, filters: {} }),
        ]);
        if (resMarcas.status === 200 || resMarcas.status === 304) {
          setMarcas(resMarcas.data || []);
        }
        const modelosData =
          resModelos.status === 200 || resModelos.status === 304
            ? Array.isArray(resModelos.data)
              ? resModelos.data
              : Array.isArray(resModelos.data?.data)
                ? resModelos.data.data
                : []
            : [];
        const marcaId =
          (filterOptions.marcas &&
            filterOptions.marcas[0] &&
            (filterOptions.marcas[0]._id ||
              filterOptions.marcas[0].id ||
              filterOptions.marcas[0])) ||
          undefined;

        const filtersSerialized = {
          ...filterOptions,
          sku: filterOptions.sku ? String(filterOptions.sku).trim() : "",
          skuExact: filterOptions.skuExact || false, // Incluir el parámetro skuExact
          marca: marcaId, // el backend filtra por 'marca'
          marcas: undefined, // evitar array que puede no ser reconocido
          // Filtrar por origin: si es "Todos" no enviar (backend muestra todos)
          ...(filterOptions.origin && filterOptions.origin !== "Todos"
            ? { origin: filterOptions.origin }
            : {}),
          timeFilter: filterOptions.timeFilter || "always", // Filtro de tiempo
          // Ventana temporal por última actividad de scrape (nuevo + refrescado), no solo createdAt
          ...(filterOptions.timeFilter && filterOptions.timeFilter !== "always"
            ? { scrapeActivityTimeFilter: true }
            : {}),
          sort: `${sortBy}-${sortOrder}`,
          // Listado scraping: siempre documentos completos (evita $group/$first con datos vacíos)
          noGroup: true,
          // Orden / filtros de actividad scraping aunque origin sea «Todos» (no se envía origin)
          scrapingBackofficeList: true,
          ...(filterOptions.excludeZeroPrice
            ? { excludeZeroPrice: true }
            : {}),
          ...(filterOptions.soloRefreshScraper
            ? { scraperRefreshOnly: true }
            : {}),
        };

        const resRelojes = await getRelojes({
          page,
          limit: pageSize,
          filters: { ...filtersSerialized, showAll: true },
        });
        if (resRelojes.status === 200 || resRelojes.status === 304) {
          const relojesApi = resRelojes.data?.data || [];
          // Solo mostrar relojes de Chrono24 (filtrado por backend)
          setData(getData(relojesApi, resMarcas.data || [], modelosData));
          // Usar total del backend (calculado correctamente después del $group en agregación)
          // Si no está disponible, usar totalPages * pageSize como fallback
          const backendTotal = resRelojes.data?.total;
          const backendTotalPages = resRelojes.data?.totalPages;
          if (backendTotal !== undefined && backendTotal !== null) {
            setTotal(backendTotal);
          } else if (backendTotalPages !== undefined && backendTotalPages !== null) {
            setTotal(backendTotalPages * pageSize);
          } else {
            // Fallback: usar longitud del array solo si no hay paginación
            setTotal(relojesApi.length);
          }
        }
        
        // Obtener TODOS los relojes sin agrupar para las estadísticas (igual que en la tasación)
        // Si se busca por SKU, usar SKU exacto para coincidir con la tasación
        const filtersForStats = { ...filtersSerialized, showAll: true, noGroup: true };
        // Si hay SKU en el filtro, forzar búsqueda exacta para estadísticas (igual que en la tasación)
        if (filtersSerialized.sku && filtersSerialized.sku.trim()) {
          filtersForStats.sku = filtersSerialized.sku.trim();
          filtersForStats.skuExact = true; // Forzar exacto para estadísticas
        }
        
        const resRelojesAll = await getRelojes({
          page: 1,
          limit: 10000, // Límite alto para obtener todos
          filters: filtersForStats,
        });
        if (resRelojesAll.status === 200 || resRelojesAll.status === 304) {
          const relojesAll = resRelojesAll.data?.data || [];
          // Guardar TODOS los relojes sin agrupar para calcular estadísticas
          setRawRelojes(relojesAll);
          console.log(`[BACKOFFICE] Total relojes para estadísticas: ${relojesAll.length}`);
          
          // Debug: verificar SKUs y marcas
          if (relojesAll.length > 0) {
            const uniqueSkus = [...new Set(relojesAll.map(r => r.sku).filter(Boolean))];
            const uniqueBrands = [...new Set(relojesAll.map(r => {
              const brand = r.brand;
              return brand?._id || brand?.id || brand;
            }).filter(Boolean))];
            console.log(`[BACKOFFICE] SKUs únicos: ${uniqueSkus.length}`, uniqueSkus.slice(0, 10));
            console.log(`[BACKOFFICE] Marcas únicas: ${uniqueBrands.length}`, uniqueBrands.slice(0, 5));
            
            // Verificar precios
            const precios = relojesAll.map(r => parseFloat(r?.price?.amount)).filter(p => !isNaN(p) && p > 0);
            console.log(`[BACKOFFICE] Precios válidos: ${precios.length}`);
            if (precios.length > 0) {
              console.log(`[BACKOFFICE] Precio min: ${Math.min(...precios)}, max: ${Math.max(...precios)}, avg: ${(precios.reduce((a, b) => a + b, 0) / precios.length).toFixed(2)}`);
            }
          }
        } else {
          // Fallback: usar los relojes agrupados si no se pueden obtener todos
          setRawRelojes(resRelojes.data?.data || []);
        }
      } catch (error) {
        // Silenciar popup en scrapping; log en consola
        console.error("Scrapping fetch error:", error?.message || error);
      } finally {
        setLoading(false);
        setRefresh(false);
      }
    };
    fetchData();
  }, [refresh, page, pageSize, filterOptions, sortBy, sortOrder]);

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const handleOpenGoogleSheets = () => {
    window.open("https://docs.google.com/spreadsheets/d/1MKFQUZv7QCEx3PXTeFaXsKMypP3f9GppAjEA7eZPeL4/edit?gid=0#gid=0", "_blank");
  };

  const handleOpenImportDialog = () => {
    setCsvText("");
    setOpenImportDialog(true);
  };

  const handleCloseImportDialog = () => {
    setOpenImportDialog(false);
    setCsvText("");
  };

  const handleImportManual = async () => {
    if (!csvText || !csvText.trim()) {
      alertError({ customMessage: "Por favor, pega el contenido del CSV antes de importar." });
      return;
    }

    try {
      setImporting(true);
      // Parsear CSV manualmente (manejar campos con comillas y saltos de línea)
      // Usar un enfoque más robusto: contar comillas para determinar si estamos dentro de un campo
      const lines = [];
      let currentLine = "";
      let inQuotes = false;
      let quoteCount = 0;
      
      for (let i = 0; i < csvText.length; i++) {
        const char = csvText[i];
        const nextChar = csvText[i + 1];
        
        if (char === '"') {
          quoteCount++;
          if (nextChar === '"') {
            // Comilla escapada (dobles comillas)
            currentLine += '""';
            i++; // Saltar la siguiente comilla
          } else {
            // Toggle estado de comillas basado en conteo par/impar
            inQuotes = (quoteCount % 2) === 1;
            currentLine += char;
          }
        } else if (char === '\n' || char === '\r') {
          if (!inQuotes) {
            // Nueva línea fuera de comillas = nueva fila
            if (currentLine.trim()) {
              lines.push(currentLine.trim());
            }
            currentLine = "";
            quoteCount = 0;
            // Saltar \r\n si existe
            if (char === '\r' && nextChar === '\n') {
              i++;
            }
          } else {
            // Salto de línea dentro de comillas = parte del contenido del campo
            currentLine += char === '\r' ? '\n' : char;
          }
        } else {
          currentLine += char;
        }
      }
      
      // Agregar la última línea si existe
      if (currentLine.trim()) {
        lines.push(currentLine.trim());
      }
      
      if (lines.length < 2) {
        alertError({ customMessage: "El CSV debe tener al menos una fila de encabezados y una fila de datos." });
        return;
      }

      // Parsear headers
      const headers = [];
      let headerLine = lines[0];
      let currentHeader = "";
      let headerInQuotes = false;
      
      for (let i = 0; i < headerLine.length; i++) {
        const char = headerLine[i];
        const nextChar = headerLine[i + 1];
        
        if (char === '"') {
          if (headerInQuotes && nextChar === '"') {
            currentHeader += '"';
            i++;
          } else {
            headerInQuotes = !headerInQuotes;
          }
        } else if (char === ',' && !headerInQuotes) {
          headers.push(currentHeader.trim().replace(/^"|"$/g, ""));
          currentHeader = "";
        } else {
          currentHeader += char;
        }
      }
      if (currentHeader.trim()) {
        headers.push(currentHeader.trim().replace(/^"|"$/g, ""));
      }

      // Parsear datos
      const csvData = lines.slice(1).map(line => {
        const values = [];
        let currentValue = "";
        let valueInQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          const nextChar = line[i + 1];
          
          if (char === '"') {
            if (valueInQuotes && nextChar === '"') {
              currentValue += '"';
              i++;
            } else {
              valueInQuotes = !valueInQuotes;
            }
          } else if (char === ',' && !valueInQuotes) {
            values.push(currentValue.trim().replace(/^"|"$/g, ""));
            currentValue = "";
          } else {
            currentValue += char;
          }
        }
        if (currentValue.trim() || values.length < headers.length) {
          values.push(currentValue.trim().replace(/^"|"$/g, ""));
        }
        
        const obj = {};
        headers.forEach((header, idx) => {
          obj[header] = values[idx] || "";
        });
        return obj;
      }).filter(row => {
        // Filtrar filas vacías o incompletas
        // Una fila válida debe tener al menos SKU y brand
        const sku = row.sku?.trim();
        const brand = row.brand?.trim();
        
        if (!sku || !brand) {
          return false;
        }
        
        // Validar que SKU no sea parte de un texto de ejemplo (como "Aldus PageMaker")
        const invalidSkuPatterns = [
          /^como por ejemplo/i,
          /^por ejemplo/i,
          /^ejemplo/i,
          /^aldus/i,
          /^pagemaker/i,
          /^el cual/i,
          /^incluye/i,
          /^versiones/i,
        ];
        
        if (invalidSkuPatterns.some(pattern => pattern.test(sku))) {
          return false;
        }
        
        // Validar que brand no sea un color o material (como "Azul", "Oro amarillo")
        const invalidBrandPatterns = [
          /^(azul|rojo|verde|amarillo|negro|blanco|gris|oro|plata)$/i,
          /^oro amarillo$/i,
          /^oro rosa$/i,
        ];
        
        if (invalidBrandPatterns.some(pattern => pattern.test(brand))) {
          return false;
        }
        
        // También verificar que tenga algún dato real (no solo campos vacíos)
        const hasData = Object.values(row).some(val => val && String(val).trim());
        return hasData;
      });

      const response = await importManualRelojes(csvData);
      
      if (response.status === 200) {
        const result = response.data;
        alertSuccess({ 
          customMessage: `Importación completada. ${result.inserted} relojes añadidos.${result.errors && result.errors.length > 0 ? ` Errores: ${result.errors.length}` : ""}` 
        });
        setRefresh(true);
        handleCloseImportDialog();
      } else {
        alertError({ customMessage: response.data?.message || "Error al importar relojes" });
      }
    } catch (error) {
      console.error("Error importing:", error);
      alertError({ error, customMessage: "Error al importar relojes" });
    } finally {
      setImporting(false);
    }
  };

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDeleteManual = async () => {
    try {
      setDeleting(true);
      const response = await deleteManualRelojes();
      
      if (response.status === 200) {
        const result = response.data;
        alertSuccess({ customMessage: `Se han borrado ${result.deletedCount} relojes añadidos manualmente.` });
        setRefresh(true);
        handleCloseDeleteDialog();
      } else {
        alertError({ customMessage: response.data?.message || "Error al borrar relojes" });
      }
    } catch (error) {
      console.error("Error deleting:", error);
      alertError({ error, customMessage: "Error al borrar relojes" });
    } finally {
      setDeleting(false);
    }
  };

  const renderFiltersContent = () => {
    return (
      <>
        <>
          <div className="row d-flex align-items-center">
            <div className="col-md-3">
              <TextField
                id="sku"
                label="idRef"
                type="text"
                value={filterOptions.sku}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    sku: event.target.value,
                  });
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-md-3">
              <InputLabel>idRef Exacto:</InputLabel>
              <FormControlLabel
                control={
                  <Switch
                    checked={filterOptions.skuExact}
                    onChange={() =>
                      setFilterOptions({
                        ...filterOptions,
                        skuExact: !filterOptions.skuExact,
                      })
                    }
                    name="skuExact"
                  />
                }
                label={filterOptions.skuExact ? "Exacto" : "Flexible"}
              />
            </div>
            <div className="col-md-3">
              <TextField
                id="precioDesde"
                label="Precio Desde"
                type="number"
                value={filterOptions.desde}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    desde: event.target.value,
                  });
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-md-3">
              <TextField
                id="precioHasta"
                label="Precio Hasta"
                type="number"
                value={filterOptions.hasta}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    hasta: event.target.value,
                  });
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-md-3">
              <InputLabel>Usado:</InputLabel>
              <FormControlLabel
                control={
                  <Switch
                    checked={filterOptions.usado}
                    onChange={() =>
                      setFilterOptions({
                        ...filterOptions,
                        usado: !filterOptions.usado,
                      })
                    }
                    name="Usado"
                  />
                }
                label={filterOptions.usado ? "Usado" : "All"}
              />
            </div>
            <div className="col-md-3">
              <InputLabel>Scraper:</InputLabel>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!filterOptions.soloRefreshScraper}
                    onChange={() =>
                      setFilterOptions({
                        ...filterOptions,
                        soloRefreshScraper: !filterOptions.soloRefreshScraper,
                      })
                    }
                    name="soloRefreshScraper"
                  />
                }
                label={
                  filterOptions.soloRefreshScraper
                    ? "Solo actualizados (scraping)"
                    : "Todos"
                }
              />
            </div>
            <div className="col-md-3">
              <InputLabel>Precio &gt; 0:</InputLabel>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!filterOptions.excludeZeroPrice}
                    onChange={() =>
                      setFilterOptions({
                        ...filterOptions,
                        excludeZeroPrice: !filterOptions.excludeZeroPrice,
                      })
                    }
                    name="excludeZeroPrice"
                  />
                }
                label={filterOptions.excludeZeroPrice ? "Sí" : "Mostrar 0 €"}
              />
            </div>
          </div>
          <div className="row d-flex align-items-center">
            <div className="col-md-4">
              <Autocomplete
                className="w-100 mr-5"
                id="autocomplete-marca"
                filterSelectedOptions
                options={marcas}
                getOptionLabel={(option) => option?.nombre}
                value={filterOptions.marcas}
                onChange={(event, selected) => {
                  setFilterOptions({ ...filterOptions, marcas: selected });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Marca"
                  />
                )}
                multiple
              />
            </div>
            <div className="col-md-4">
              <Autocomplete
                className="w-100 mr-5"
                id="autocomplete-localizacione"
                filterSelectedOptions
                options={["Europa", "Japón", "EEUU", "Otros"]}
                // getOptionLabel={(option) => option?.nombre}
                value={filterOptions.localizaciones}
                onChange={(event, selected) => {
                  setFilterOptions({
                    ...filterOptions,
                    localizaciones: selected,
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Localizacion"
                  />
                )}
                multiple
              />
            </div>
            <div className="col-md-4">
              <Autocomplete
                className="w-100 mr-5"
                id="autocomplete-timeFilter"
                options={[
                  { value: "1h", label: "Última hora" },
                  { value: "24h", label: "Últimas 24h" },
                  { value: "week", label: "Última semana" },
                  // { value: "month", label: "Último mes" }, // Comentado temporalmente
                  { value: "always", label: "Siempre" },
                ]}
                getOptionLabel={(option) => option.label || option}
                value={
                  filterOptions.timeFilter
                    ? { 
                        value: filterOptions.timeFilter, 
                        label: filterOptions.timeFilter === "1h" ? "Última hora" 
                          : filterOptions.timeFilter === "24h" ? "Últimas 24h" 
                          : filterOptions.timeFilter === "week" ? "Última semana" 
                          : filterOptions.timeFilter === "month" ? "Último mes" 
                          : "Siempre" 
                      }
                    : { value: "always", label: "Siempre" }
                }
                onChange={(event, selected) => {
                  setFilterOptions({
                    ...filterOptions,
                    timeFilter: selected?.value || "always",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Período de tiempo"
                  />
                )}
              />
            </div>
            <div className="col-md-4">
              <Autocomplete
                className="w-100 mr-5"
                id="autocomplete-origin"
                options={[
                  { value: "Todos", label: "Todos" },
                  { value: "chrono24", label: "Chrono24" },
                  { value: "manual", label: "Manual" },
                  { value: "tasacion", label: "Tasación (Chrono24 + Manual)" },
                  { value: "wordpress", label: "WordPress" },
                  { value: "TuRelojYa", label: "TuRelojYa" },
                  { value: "other", label: "Otro" },
                ]}
                getOptionLabel={(option) => option?.label ?? option ?? ""}
                value={[
                  { value: "Todos", label: "Todos" },
                  { value: "chrono24", label: "Chrono24" },
                  { value: "manual", label: "Manual" },
                  { value: "tasacion", label: "Tasación (Chrono24 + Manual)" },
                  { value: "wordpress", label: "WordPress" },
                  { value: "TuRelojYa", label: "TuRelojYa" },
                  { value: "other", label: "Otro" },
                ].find((o) => o.value === (filterOptions.origin || "chrono24")) || { value: "chrono24", label: "Chrono24" }}
                onChange={(event, selected) => {
                  setFilterOptions({
                    ...filterOptions,
                    origin: selected?.value ?? "chrono24",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Origen"
                  />
                )}
              />
            </div>
          </div>
        </>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Relojes"></CardHeader>
        <CardBody>
          {/* Sección Añadir manualmente */}
          <div style={{ marginBottom: "20px", padding: "16px", backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
            <h4 style={{ marginBottom: "12px" }}>Añadir manualmente</h4>
            <p style={{ fontSize: 13, marginBottom: 12 }}>
              Usa esta sección para importar relojes manualmente desde una hoja de cálculo.
            </p>
            <ol style={{ fontSize: 13, paddingLeft: 20, marginBottom: 14 }}>
              <li style={{ marginBottom: 4 }}>
                Abre la plantilla de la hoja de cálculo:&nbsp;
                <a
                  href="https://docs.google.com/spreadsheets/d/1MKFQUZv7QCEx3PXTeFaXsKMypP3f9GppAjEA7eZPeL4/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  abrir
                </a>
              </li>
              <li style={{ marginBottom: 4 }}>
                Rellena las casillas con los relojes que quieres que formen parte de este scrapping manual.
              </li>
              <li style={{ marginBottom: 4 }}>
                Exporta esta hoja de cálculo en formato <strong>CSV</strong>.
              </li>
              <li style={{ marginBottom: 4 }}>
                Abre el archivo CSV y copia <strong>TODO</strong> el contenido.
              </li>
              <li>
                En el backoffice pulsa <strong>Añadir</strong> y pega el contenido del CSV en el campo
                &nbsp;<strong>"Contenido del CSV"</strong>.
              </li>
            </ol>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleOpenGoogleSheets}
                disabled={importing || deleting}
              >
                Abrir plantilla
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenImportDialog}
                disabled={importing || deleting}
              >
                Añadir
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenDeleteDialog}
                disabled={importing || deleting}
              >
                {deleting ? "Borrando..." : "Borrar todos los relojes añadidos manualmente"}
              </Button>
            </div>
          </div>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
          />
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <CircularProgress className={classes.fancyLoader} />
            </div>
          ) : (
            <>
              <Table
                data={data}
                columns={columns}
                page={page}
                pageSize={pageSize}
                total={total}
                onPageChange={setPage}
                onPageSizeChange={setPageSize}
                getRowStyle={(row) => {
                  const kind = row?.original?._rowStyle;
                  if (kind === "updated") {
                    return { backgroundColor: "#e8f5e9" };
                  }
                  if (kind === "new") {
                    return { backgroundColor: "#e3f2fd" };
                  }
                  return {};
                }}
              />
              {rawRelojes.length > 0 && filterOptions.sku && String(filterOptions.sku).trim() && (
                <div style={{ marginTop: "30px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                  <h3 style={{ marginBottom: "10px", color: "#333" }}>Estadísticas de Precios</h3>
                  <p style={{ marginBottom: "20px", fontSize: "14px", color: "#666", fontStyle: "italic" }}>
                    <strong>Nota:</strong> La tabla muestra <strong>{rawRelojes.length} relojes individuales</strong> sin agrupar. 
                    Las estadísticas se calculan usando los mismos relojes, igual que en la herramienta de tasación.
                  </p>
                  {calculatePriceStats(rawRelojes, constants)}
                </div>
              )}
            </>
          )}
        </CardBody>
      </Card>

      {/* Dialog para importar CSV */}
      <Dialog
        open={openImportDialog}
        onClose={handleCloseImportDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Importar relojes desde Excel</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: "20px" }}>
            <strong>Advertencia:</strong> Se añadirán todos los relojes que contenga el Excel. 
            Si desea reemplazar los añadidos anteriormente de otras importaciones desde Excel, 
            debe eliminarlos previamente usando el botón "Borrar todos los relojes añadidos manualmente".
          </DialogContentText>
          <TextField
            label="Contenido del CSV"
            helperText="Primera fila = encabezados. Columnas esperadas: nRef, sku, name, brand, model, any, price_amount, price_currency, seller_name, seller_country, estado_usado (true/false), estuche (true/false), documento (true/false), estado_calificacion, description, esfera, material_caja, images[0]…images[19]. nRef = número de referencia (ref. fabricante), any = año."
            multiline
            rows={12}
            fullWidth
            variant="outlined"
            value={csvText}
            onChange={(e) => setCsvText(e.target.value)}
            placeholder="Pega el contenido del CSV aquí..."
            style={{ 
              marginTop: "10px",
            }}
            InputProps={{
              style: {
                fontFamily: "monospace",
                fontSize: "13px",
                lineHeight: "1.5"
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImportDialog} disabled={importing}>
            Cancelar
          </Button>
          <Button
            onClick={handleImportManual}
            color="primary"
            variant="contained"
            disabled={importing || !csvText.trim()}
          >
            {importing ? "Importando..." : "Importar"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog para confirmar eliminación */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <strong>Advertencia:</strong> Se eliminarán todos los relojes importados manualmente. 
            <strong> No se eliminarán los relojes obtenidos de chrono24.</strong>
            <br /><br />
            Esta acción no se puede deshacer. ¿Está seguro de que desea continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} disabled={deleting}>
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteManual}
            color="secondary"
            variant="contained"
            disabled={deleting}
          >
            {deleting ? "Borrando..." : "Eliminar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
